import { render, staticRenderFns } from "./TenantDetail.vue?vue&type=template&id=7cd38b6d&"
import script from "./TenantDetail.vue?vue&type=script&lang=ts&"
export * from "./TenantDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports